import { render } from "./ChatMessages.vue?vue&type=template&id=72adf6cd&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"

import "./ChatMessages.vue?vue&type=style&index=0&id=72adf6cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72adf6cd"]])

export default __exports__